














































































































import {Component, PropSync, Watch} from "vue-property-decorator";
import { Action, Getter, namespace } from "vuex-class";
import { SelectWings, ToggleWings } from "wings-ui-components";
import {notifyError} from "@/utils/notify-helper";
import BaseFilter from "@/components/Filter/BaseFilter";
import { PartnerUserFilter } from "@/store/user_management/partner_users/types";
import {getTranslatedParams} from "@/utils/notify-utils";

const partnerUsersModule = namespace("@/store/user_management/partner_users");

@Component({
  components: {
    SelectWings,
    ToggleWings,
  },
})
export default class PartnerUsersFilter extends BaseFilter<PartnerUserFilter> {
  @PropSync('filterProp') filterParent!: any;
  @PropSync('runFilter') run!: any;
  @PropSync("show") is_show!: boolean;

  @partnerUsersModule.Getter("partnerUsers") partnerUsersList: any;
  // @Getter("partnerUsers") partnerUsersList: any;
  // @Getter("partners") partnersList: any;
  @Getter("partnerUserRoles") partnerUserRolesList: any;

  @Action("getPartnerUsers") actionGetPartnerUsers: any;
  @Action("getPartnerUserRoles") actionGetPartnerUserRoles: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("exportPartnerUsers") actionExportPartnerUsers: any;

  private statusesList = [1, 0];
  partnersList: any = []

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners(filter);
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  get partnerUserRoles(){
    return [{ id: 0, name: '--Без роли--' }].concat(this.partnerUserRolesList);
  }

  async created() {
    this.actionGetPartnerUserRoles();
    this.filtered();
    this.scroll();
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
  }

  defaultFilter(): PartnerUserFilter {
    return {
      id: undefined,
      email: undefined,
      name: undefined,
      partner: undefined,
      status: undefined,
      role_id: undefined,
      page_number: 1
    };
  }

  async onFilteredAction(nextPage = false) {
    if (!nextPage) this.filter.page_number = 1;
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Personal account",
        addititional_info: getTranslatedParams(this.filter)
      }
      const resp = await this.actionGetPartnerUsers({ ...this.filter, ...{ is_ad_user: 0 } }).catch((error: any) => {
        notifyError("Ошибка сервера", error);
      });
      await this.actionLog(this.logObject);
      this.is_last = resp.length == 0;
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    } finally {
      this.moreLoading = false;
    }
  }

  export(): void {
    this.logObject = {
      action_page: this.$route.meta.msgKey,
      action: "Export",
      action_status: "success",
      object_type: "Personal account",
      addititional_info: getTranslatedParams(this.filter)
    }
    this.actionExportPartnerUsers(this.filter).then(()=>{
      this.actionLog(this.logObject);
    }).catch((error:any) => {
      this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(error);
    })
  }

  getPartnerRolesNameById(id: number): string | undefined {
    if (id === 0) return '--Без роли--';
    return this.partnerUserRolesList.find((e: any) => e.id === id)?.name;
  }

  @Watch('filter', {immediate: true, deep: true})
  onFilterChanged(val: PartnerUserFilter) {
    this.filterParent = val;
  }

  @Watch('run')
  onRunFilter(val: boolean) {
    if (!val) return;
    this.filtered();
    this.run = false;
  }
}
